export default "__VITE_ASSET__7187bacd__"